import React,{useState,useRef} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'
import Cart from '../../shared/cart'

import {closeCallback} from '../../../app/action'
import KeepShoppingButton from '../../shared/closebutton/keepShoppingButton'

let Viewcart = (props) =>{
  const {history} = props
  const dispatch = useDispatch()
  const {cartStatus} = useSelector(state=>({
    cartStatus: state.app.cartStatus
  }))
  const [slideout,setslideout] = useState(false)
  const timer = useRef(null)
  const slideoutCallback = () => {
    setslideout(true)
    if(timer.current){
      window.clearTimeout(timer.current)
    }
    timer.current = window.setTimeout(()=>{

    },300)
  }
  const overlayOnClick = () =>{
    if(cartStatus==="success"){
      slideoutCallback()
      closeCallback(dispatch,history)
    }
  }
  return (
    <div className={`of-viewcart`}>
      <div className={'of-viewcart__overlay'} onClick={overlayOnClick}/>
      <div className={`of-viewcart__main${slideout?' of-viewcart__main--slideout':''}`}>
        {cartStatus==="success" || cartStatus==="error"?<KeepShoppingButton className={'of-viewcart__closebutton'}  callback={slideoutCallback}/>:<></>}
        <Cart className={`of-viewcart__cart`}/>
      </div>
    </div>
  )
}

Viewcart = withRouter(Viewcart)

Viewcart.propTypes = {
  history: PropTypes.any
}

export default Viewcart